import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

function PendingApprovalScreen() {
  const { signOut } = useAuth()

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
      height: '100vh', gap: 'var(--space-4)', fontFamily: 'var(--font-display)',
      padding: 'var(--space-4)', textAlign: 'center', background: 'var(--color-bg)',
    }}>
      <div style={{
        width: 64, height: 64, borderRadius: '50%', background: 'var(--color-primary-muted)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="var(--color-primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
      </div>
      <h1 style={{ fontSize: 'var(--text-2xl)', fontWeight: 700 }}>Application Under Review</h1>
      <p style={{ color: 'var(--color-text-muted)', maxWidth: 480, lineHeight: 1.6 }}>
        Your trade account application is being reviewed by our team.
        You'll receive an email once your account has been approved.
      </p>
      <button
        onClick={signOut}
        style={{
          marginTop: 'var(--space-4)', padding: 'var(--space-3) var(--space-6)',
          background: 'var(--color-bg-elevated)', border: '1px solid var(--color-border)',
          borderRadius: 'var(--radius-md)', cursor: 'pointer', fontFamily: 'var(--font-display)',
          fontSize: 'var(--text-sm)', color: 'var(--color-text-secondary)',
        }}
      >
        Sign out
      </button>
    </div>
  )
}

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, profile, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100vh', fontFamily: 'var(--font-display)', color: 'var(--color-text-muted)',
      }}>
        Loading...
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/gaviota/login" state={{ from: location }} replace />
  }

  if (profile && !profile.is_active) {
    return <PendingApprovalScreen />
  }

  if (!profile) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100vh', fontFamily: 'var(--font-display)', color: 'var(--color-text-muted)',
      }}>
        Loading...
      </div>
    )
  }

  // Redirect keder_admin away from vendor portal to admin dashboard
  if (profile.role === 'keder_admin' && location.pathname.startsWith('/gaviota')) {
    return <Navigate to="/admin" replace />
  }

  return <>{children}</>
}
